var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.125 8.36666C15.5583 5.49167 13.0333 3.33333 10 3.33333C7.59167 3.33333 5.5 4.7 4.45833 6.7C1.95 6.96667 0 9.09166 0 11.6667C0 14.425 2.24167 16.6667 5 16.6667H15.8333C18.1333 16.6667 20 14.8 20 12.5C20 10.3 18.2917 8.51666 16.125 8.36666ZM14.1667 10.8333L10 15L5.83333 10.8333H8.33333V7.5H11.6667V10.8333H14.1667Z","fill":"#FEFEFE"}));
}

Download.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Download;

Download.default = Download;
